var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M3.81 8a.55.55 0 0 1 .55-.55h5.427l-1.53-1.589a.55.55 0 1 1 .792-.763l2.427 2.52a.55.55 0 0 1 0 .763l-2.427 2.52a.55.55 0 1 1-.792-.763l1.53-1.588H4.36A.55.55 0 0 1 3.81 8M8 13.9A5.9 5.9 0 1 0 8 2.1a5.9 5.9 0 1 0 0 11.8M8 15A7 7 0 1 0 8 1a7 7 0 1 0 0 14"
})));
export { SvgCircleArrowRight as ReactComponent };